<template>
    <div>
        <Modal v-model="payModal" width="35%" :closable="false" :mask-closable="false">
            <div slot="header" class="pay-title">
                <span>支付信息</span>
            </div>
            <Tabs type="card" style="text-align: center">
                <TabPane name="1" label="微信支付">
                    <div class="tab-pane-left">
                        <div>扫一扫付款（元）</div>
                        <div class="money">{{ total }}</div>
                        <div id="wx-qrcode" class="qrcode"></div>
                        <div>订单号：{{ orderNum }}</div>
                    </div>
                    <div class="tab-pane-right">
                        <div class="tab-pane-right-img">
                            <img src="../../static/images/weChatPay.png" alt="" />
                        </div>
                    </div>
                </TabPane>
                <TabPane name="2" label="支付宝支付">
                    <div class="tab-pane-left">
                        <div>扫一扫付款(元)</div>
                        <div class="money">{{ total }}</div>
                        <!-- <div id="ali-qrcode" class="qrcode"></div> -->
                        <div class="qrcode">
                            <iframe :srcdoc="iframeUrl" frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" width="500" height="500" style="overflow: hidden">
                            </iframe>
                        </div>
                        <div>订单号:{{ orderNum }}</div>
                    </div>
                    <div class="tab-pane-right">
                        <div class="tab-pane-right-img">
                            <img src="../../static/images/aliPay.png" alt="" />
                        </div>
                    </div>
                </TabPane>
                <!-- <TabPane name="2" label="支付宝支付">
                    <div class="tab-pane-left">
                        <div>扫一扫付款（元）</div>
                        <div class="money">{{ total }}</div>
                        <div id="ali-qrcode" class="qrcode"></div>
                        <div>订单号：{{ orderNum }}</div>
                    </div>
                    <div class="tab-pane-right">
                        <div class="tab-pane-right-img">
                            <img src="../../static/images/aliPay.png" alt="" />
                        </div>
                    </div>
                </TabPane> -->
            </Tabs>
            <div slot="footer">
                <Button type="warning" @click="handleClose">关闭</Button>
            </div>
        </Modal>
        <!--发票modal-->
        <Invoice ref="invoice" :total="total" :orderNum="orderNum"></Invoice>
    </div>
</template>

<script>
import Invoice from "./Invoice";
import QRCode from "qrcodejs2";
import {
    postWxpayUnifiedUrl,
    postAlipayUnifiedUrlWm,
    getOrderCheck,
} from "../api/pay";
export default {
    name: "Pay",
    props: {
        total: {
            type: Number,
            default: 0,
        },
        orderNum: {
            type: String,
            default: "",
        },
    },
    components: {
        Invoice,
    },
    data() {
        return {
            //支付modal
            payModal: false,
            //定时关闭时间(秒)
            timerLength: 60,
            //
            iframeUrl: "",
        };
    },
    watch: {
        //监听modal的显现
        payModal(val) {
            if (val) {
                this.postWxpayUnifiedUrl();
                this.postAlipayUnifiedUrl();
                this.createTimer();
            } else {
                clearInterval(this.timer);
            }
        },

        //监听支付剩余时间
        timerLength(val) {
            if (val <= 0) {
                this.payModal = false;
                clearInterval(this.timer);
                this.timerLength = 60;
            }
        },
    },
    methods: {
        //微信支付
        async postWxpayUnifiedUrl() {
            let payParams = {
                paymentType: 1,
                orderId: this.orderNum,
            };
            let res = await postWxpayUnifiedUrl(payParams);
            this.wxQrcode(res.data.paymentQrCode);
        },

        //支付宝支付
        async postAlipayUnifiedUrl() {
            let payParams = {
                paymentType: 2,
                orderId: this.orderNum,
            };
            let res = await postAlipayUnifiedUrlWm(payParams);
            // this.aliQrcode(res.paymentQrCode);
            console.log("支付宝返回值Code", res.data.paymentQrCode);
            this.iframeUrl = res.data.paymentQrCode;
        },

        //微信支付
        wxQrcode(qrCode) {
            document.getElementById("wx-qrcode").innerHTML = "";
            console.log("qrCode", qrCode);
            let qrcode = new QRCode(document.getElementById("wx-qrcode"), {
                width: 198,
                height: 198,
                text: qrCode, // 二维码内容
            });
        },

        //支付宝支付
        aliQrcode(qrCode) {
            document.getElementById("ali-qrcode").innerHTML = "";
            let qrcode = new QRCode(document.getElementById("ali-qrcode"), {
                width: 198,
                height: 198,
                text: qrCode, // 二维码内容
            });
        },

        //支付定时轮循
        createTimer() {
            this.timer = setInterval(() => {
                this.timerLength -= 3;
                getOrderCheck(this.orderNum).then((res) => {
                    if (res.code == 200) {
                        if (res.data) {
                            if (res.data.status == 2) {
                                // this.$Message.info("支付成功");
                                setTimeout(() => {
                                    this.$Modal.success({
                                        title: "提示",
                                        content: "支付成功",
                                        onOk: () => {
                                            clearInterval(this.timer);
                                            this.payModal = false;
                                            this.$emit("Success");
                                        },
                                    });
                                }, 300);

                                return;
                                this.$Message.info(
                                    "支付成功,请选择是否要开发票"
                                );
                                clearInterval(this.timer);
                                this.payModal = false;
                                this.$refs.invoice.invoiceModal = true;
                                this.$emit("Success");
                            }
                        }
                    }
                });
            }, 3000);
        },

        //关闭支付弹框
        handleClose() {
            clearInterval(this.timer);
            this.payModal = false;
            this.$emit("Success");
            this.timerLength = 60;
        },
    },
};
</script>

<style scoped>
.money {
    font-size: 26px;
    font-weight: 700;
    color: #f60;
}

.qrcode {
    display: inline-block;
    margin-bottom: 10px;
    overflow: hidden;
    width: 198px;
    height: 198px;
}

.pay-title {
    color: #4f8dfe;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
}

.tab-pane-left {
    width: 50%;
    float: left;
}

.tab-pane-right {
    width: 49%;
    float: left;
    height: 100%;
}

.tab-pane-right-img {
    width: 85%;
    height: 100%;
    margin: 0 auto;
}

.tab-pane-right-img img {
    height: 100%;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Pay.vue